import React from 'react';
// material ui
import Checkbox from '@material-ui/core/Checkbox';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

import AppActions from '../../actions/app-actions';
import ExpandedDevice from './expanded-device';

import {getColumnHeaders} from './helper';

export default class DeviceListItem extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    const {localConfInfo={}, actionInfo={}} = props.device || {};
    this.state = {
      expandedDevice: null,
      basicInstall: localConfInfo,
      actionInfo: actionInfo,
      device: props.device,
      isMouseInside: null,
    };

    /** Bind methods */
    this._selectOnClickBind = this._selectOnClick.bind(this);
    this._updateBasicInstallBind = this._updateBasicInstall.bind(this);
    this._updateActionInfoBind = this._updateActionInfo.bind(this);
    this._updateconfigBind = this._updateconfig.bind(this);
  }

  _updateBasicInstall(lconf) {
    this.setState({basicInstall: lconf});
  }

  _updateActionInfo(actionInfo) {
    this.setState({actionInfo});
  }

  _updateconfig(config) {
    this.setState(prev => {
      return ({ device:
      { ...prev.device, type: config.type, config_name: config.configName,
        flavor_name: config.flavorName, label: config.label,
        configInfo: { ...prev.device.configInfo,
          configuration: { ...prev.device.configInfo.configuration, name: config.configName},
          flavor: { ...prev.device.configInfo.flavor, name: config.flavorName}
        }
      }});
    });
  }

  /*
   * Get full device identity details for single selected device
   */
  getDeviceDetails(device) {
    var self = this;
    return AppActions.getDeviceAuth(device.id)
      .then(data =>
        self.setState({
          expandedDevice: {
            identity_data: data.identity_data,
            created_ts: data.created_ts,
            status: data.status,
            ...device
          }
        })
      )
      .catch(err => console.log(`Error: ${err}`));
  }

  /** To stop the key progated to ExpansionPanel panel */
  _selectOnClick(e) {
    e.stopPropagation();
  }

  mouseEnter = (event) => {
    this.setState({ isMouseInside: event.currentTarget });
  }

  mouseLeave = () => {
    this.setState({ isMouseInside: null });
  }

  render() {
    const self = this;
    const { type, expanded, onClick, onRowSelect, selectable, selected, idx } = self.props;
    const { device } = this.state;
    const columnHeaders = getColumnHeaders(type);

    if (expanded && !self.state.expandedDevice) {
      self.getDeviceDetails(device);
    }

    const id_attribute = device.identity_data ? device.identity_data.UUID : '-';

    const open = Boolean(this.state.isMouseInside);
    const id = (this.state.isMouseInside) ? 'simple-popover' : undefined;
    return (
      <ExpansionPanel deviceidx={idx} className="deviceListItem" square expanded={expanded} onChange={onClick}>
        <ExpansionPanelSummary style={{ padding: '0 12px' }}>
          {
            selectable
              ? <Checkbox inputProps={{'deviceidx': idx}} checked={selected} onChange={onRowSelect} onClick={this._selectOnClickBind} />
              : null
          }
          {
            columnHeaders.map((item, index) => {
              const key = `column-${index}`;
              const style = Object.assign({ padding: '0 15px', width: '-webkit-fill-available' }, item.style);
              return (
                item.name === 'comment'
                  ? <div key={key} style={style} onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave} aria-describedby="mouse-over-popover">
                    {item.render(device)}
                  </div>
                  : <div key={key} style={style}>
                    {item.render(device)}
                  </div>
              )
            })
          }
          {device.comment ? <Popover
            id={id}
            open={open}
            data-trigger="hover"
            anchorEl={this.state.isMouseInside}
            onClose={this.mouseLeave}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            style={{ pointerEvents: 'none', maxWidth: '50%', maxHeight: '100%' }}
          >
            <div style={{width:'fitContent', padding: '15px 15px'}}>{device.comment}</div>
          </Popover> : null}
          <IconButton className="expandButton">{expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</IconButton>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          {expanded && self.state.expandedDevice && self.state.expandedDevice.id === device.id ? (
            <ExpandedDevice
              {...self.props}
              className="expandedDevice"
              id_attribute={id_attribute}
              id_value={id_attribute}
              device={device}
              attrs={device.attributes}
              unauthorized={device.status !== 'accepted'}
              device_type={device.attributes ? device.attributes.device_type : null}
              basicInstall={this.state.basicInstall}
              updateBasicInstall={this._updateBasicInstallBind}
              actionInfo={this.state.actionInfo}
              updateActionInfo={this._updateActionInfoBind}
              updateconfig={this._updateconfigBind}
            />
          ) : (
            <div />
          )}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}
